import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Display, NewDisplay, Room } from 'src/app/models/checkin';
import { CheckinService } from 'src/app/services/checkin/checkin.service';

/**
 * Back office page "Anzeigen": the check-in displays (one tablet/phone per
 * room). Creating one shows its set-up link once; blocking one makes its
 * page show "nicht eingerichtet".
 */
@Component({
  selector: 'li-displays',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './displays.component.html',
  styleUrls: ['./displays.component.scss']
})
export class DisplaysComponent implements OnInit {
  public displays: Display[] = [];
  public rooms: Room[] = [];
  public label = '';
  public pid = 1;
  public created?: NewDisplay;
  public copied = false;

  constructor(private checkinService: CheckinService) {}

  ngOnInit(): void {
    this.load();
    this.checkinService.rooms().subscribe({
      next: rooms => {
        this.rooms = rooms;
        if (rooms.length > 0 && !rooms.some(r => r.pid === this.pid)) this.pid = rooms[0].pid;
      },
      error: () => this.rooms = [{ pid: 1, name: 'Plan 1' }]
    });
  }

  public add(): void {
    const label = this.label.trim();
    if (!label) return;

    this.checkinService.addDisplay(label, this.pid).subscribe({
      next: created => {
        this.created = created;
        this.copied = false;
        this.label = '';
        this.load();
      },
      error: () => alert('Die Anzeige konnte nicht angelegt werden.')
    });
  }

  public copy(): void {
    if (!this.created) return;
    navigator.clipboard?.writeText(this.created.url).then(() => this.copied = true);
  }

  public revoke(display: Display): void {
    if (!confirm(`Soll die Anzeige „${display.label}“ wirklich gesperrt werden? Sie zeigt dann keine Codes mehr.`)) return;

    this.checkinService.revokeDisplay(display.id).subscribe({
      next: () => this.load(),
      error: () => alert('Die Anzeige konnte nicht gesperrt werden.')
    });
  }

  private load(): void {
    this.checkinService.displays().subscribe({
      next: displays => this.displays = displays,
      error: () => this.displays = []
    });
  }
}
